export default () => ({
  content: {
    marginRight: 24,
  },
});
